export const UX = {
  skeleton: {
    minDelay: 1000
  }
}